export default {
  title: 'Geliefert mit',
  text: 'Unsere Partnerschaft mit Uber und Foodamigos ermöglicht es uns, Lieferungen direkt über unsere Webseite anzubieten, was uns im Vergleich zu anderen Plattformen <strong>{{savings}}</strong> an Lieferprovisionen pro Bestellung spart',
};